import React from 'react';
import bg2 from "../../../assets/img/business-office1.png";
import {Link} from "react-router-dom";

const HeroSection = ({title}) => {
    return (
        <section className="hero-wrap hero-wrap-2" style={{backgroundImage: `url(${bg2})`}}
                 data-stellar-background-ratio="0.5">
            <div className="overlay"/>
            <div className="container">
                <div className="row no-gutters slider-text js-fullheight align-items-center justify-content-center">
                    <div className="col-md-9 ftco-animate pb-0 text-center">
                        {/* <p className="breadcrumbs"><span className="mr-2"><Link to="/">Home<i
                            className="fa fa-chevron-right"/></Link></span>
                            </p>*/}
                        <h2 className="mb-3 bread text-white">{title}</h2>
                        <h5 className="text-white">{/*Lorem ipsum dolor sit amet, consectetur adipisicing elit.*/}</h5>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;